module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "books_by_title"
  }, [_vm._v("Books by Clifford A. Pickover")]), _vm._v(" "), _c('p', {
    staticClass: "books_by"
  }, [_c('i', [_vm._v("The Alien IQ Test")])]), _vm._v(" "), _c('p', {
    staticClass: "books_by"
  }, [_c('i', [_vm._v("Archimedes to Hawking")])]), _vm._v(" "), _c('p', {
    staticClass: "books_by"
  }, [_c('i', [_vm._v("A Beginner’s Guide to Immortality")])]), _vm._v(" "), _c('p', {
    staticClass: "books_by"
  }, [_c('i', [_vm._v("Black Holes: A Traveler’s Guide")])]), _vm._v(" "), _c('p', {
    staticClass: "books_by"
  }, [_c('i', [_vm._v("Calculus and Pizza")])]), _vm._v(" "), _c('p', {
    staticClass: "books_by"
  }, [_c('i', [_vm._v("Chaos and Fractals")])]), _vm._v(" "), _c('p', {
    staticClass: "books_by"
  }, [_c('i', [_vm._v("Chaos in Wonderland")])]), _vm._v(" "), _c('p', {
    staticClass: "books_by"
  }, [_c('i', [_vm._v("Computers, Pattern, Chaos, and Beauty")])]), _vm._v(" "), _c('p', {
    staticClass: "books_by"
  }, [_c('i', [_vm._v("Computers and the Imagination")])]), _vm._v(" "), _c('p', {
    staticClass: "books_by"
  }, [_c('i', [_vm._v("Cryptorunes: Codes and Secret Writing")])]), _vm._v(" "), _c('p', {
    staticClass: "books_by"
  }, [_c('i', [_vm._v("Dreaming the Future")])]), _vm._v(" "), _c('p', {
    staticClass: "books_by"
  }, [_c('i', [_vm._v("Egg Drop Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "books_by"
  }, [_c('i', [_vm._v("Future Health")])]), _vm._v(" "), _c('p', {
    staticClass: "books_by"
  }, [_c('i', [_vm._v("Fractal Horizons: The Future Use of Fractals")])]), _vm._v(" "), _c('p', {
    staticClass: "books_by"
  }, [_c('i', [_vm._v("Frontiers of Scientific Visualization")])]), _vm._v(" "), _c('p', {
    staticClass: "books_by"
  }, [_c('i', [_vm._v("The Girl Who Gave Birth to Rabbits")])]), _vm._v(" "), _c('p', {
    staticClass: "books_by"
  }, [_c('i', [_vm._v("The Heaven Virus")])]), _vm._v(" "), _c('p', {
    staticClass: "books_by"
  }, [_c('i', [_vm._v("Keys to Infinity")])]), _vm._v(" "), _c('p', {
    staticClass: "books_by"
  }, [_c('i', [_vm._v("Liquid Earth")])]), _vm._v(" "), _c('p', {
    staticClass: "books_by"
  }, [_c('i', [_vm._v("The Lobotomy Club")])]), _vm._v(" "), _c('p', {
    staticClass: "books_by"
  }, [_c('i', [_vm._v("The Loom of God")])]), _vm._v(" "), _c('p', {
    staticClass: "books_by"
  }, [_c('i', [_vm._v("The Mathematics of Oz")])]), _vm._v(" "), _c('p', {
    staticClass: "books_by"
  }, [_c('i', [_vm._v("Mazes for the Mind: Computers and the Unexpected")])]), _vm._v(" "), _c('p', {
    staticClass: "books_by"
  }, [_c('i', [_vm._v("Mind-Bending Visual Puzzles")]), _vm._v(" (calendars and card sets)")]), _vm._v(" "), _c('p', {
    staticClass: "books_by"
  }, [_c('i', [_vm._v("The Möbius Strip")])]), _vm._v(" "), _c('p', {
    staticClass: "books_by"
  }, [_c('i', [_vm._v("The Paradox of God and the Science of Omniscience")])]), _vm._v(" "), _c('p', {
    staticClass: "books_by"
  }, [_c('i', [_vm._v("A Passion for Mathematics")])]), _vm._v(" "), _c('p', {
    staticClass: "books_by"
  }, [_c('i', [_vm._v("The Pattern Book: Fractals, Art, and Nature The Science of Aliens")])]), _vm._v(" "), _c('p', {
    staticClass: "books_by"
  }, [_c('i', [_vm._v("Sex, Drugs, Einstein, and Elves")])]), _vm._v(" "), _c('p', {
    staticClass: "books_by"
  }, [_c('i', [_vm._v("Spider Legs")]), _vm._v(" (with Piers Anthony)")]), _vm._v(" "), _c('p', {
    staticClass: "books_by"
  }, [_c('i', [_vm._v("Spiral Symmetry")]), _vm._v(" (with Istvan Hargittai)")]), _vm._v(" "), _c('p', {
    staticClass: "books_by"
  }, [_c('i', [_vm._v("Strange Brains and Genius")])]), _vm._v(" "), _c('p', {
    staticClass: "books_by"
  }, [_c('i', [_vm._v("Sushi Never Sleeps")])]), _vm._v(" "), _c('p', {
    staticClass: "books_by"
  }, [_c('i', [_vm._v("The Stars of Heaven")])]), _vm._v(" "), _c('p', {
    staticClass: "books_by"
  }, [_c('i', [_vm._v("Surfing through Hyperspace")])]), _vm._v(" "), _c('p', {
    staticClass: "books_by"
  }, [_c('i', [_vm._v("Time: A Traveler’s Guide")])]), _vm._v(" "), _c('p', {
    staticClass: "books_by"
  }, [_c('i', [_vm._v("Visions of the Future")])]), _vm._v(" "), _c('p', {
    staticClass: "books_by"
  }, [_c('i', [_vm._v("Visualizing Biological Information")])]), _vm._v(" "), _c('p', {
    staticClass: "books_by"
  }, [_c('i', [_vm._v("Wonders of Numbers")])]), _vm._v(" "), _c('p', {
    staticClass: "books_by"
  }, [_c('i', [_vm._v("The Zen of Magic Squares, Circles, and Stars")])]), _vm._v(" "), _c('p', {
    staticClass: "books_by"
  }, [_c('i', [_vm._v("The Physics Book")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4e333e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/books_by.vue
// module id = 60
// module chunks = 0